import React, { useMemo } from 'react';
import Modal from '@components/common/Modal';
import style from '../storeChecksCopy.module.scss';
import cn from 'classnames';
import { CUSTOM_MESSAGES, LABEL} from '../../../veriables';
import { TouchableButton } from '../../common/Touchable/index';
import { closeManagerCheck } from '@reducers/oauth';
import { useDispatch } from 'react-redux';



const VoidCheckModal = ({setIsVoidOpen, isVoidOpen, setVoidCheck, handleVoidChecks, handleVoidItems, setIsToolsPopUp, serverAppTheme, voidCheck, setToolsModalOpen, ...props}) => {
  const dispatch = useDispatch();
  const popupStyles = useMemo(() => {
    const modalStyle = {
      backgroundColor:serverAppTheme?.popUp_bg,
      borderRadius:'16px',
      width: '486px',
      margin:'auto',
      minHeight: voidCheck ? props.seat.paidAmount > 0 ? "235px" : '216px' : '216px',
      padding:'1.5rem',
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow
    }
    const parentModalStyle = {color: serverAppTheme?.primary_text}
    const buttonStyles = {bottom: voidCheck ? props.seat.paidAmount > 0 ? "20px" : '26px' : '26px', left:'20px'}
    const noButton = {
      backgroundColor: serverAppTheme?.OFF_Premise_Btn,
      border: serverAppTheme?.cancleBtn_Border,
      color: serverAppTheme?.cancleBtn_font
    }
    const yesButton = {backgroundColor: serverAppTheme?.secondaryBtn, color:serverAppTheme?.btn_font_color}

    return {modalStyle, parentModalStyle, buttonStyles, noButton, yesButton};
  },[serverAppTheme, voidCheck, props.seat.paidAmount])
  const handleYesClick = () => {
    setIsVoidOpen(false);
    setToolsModalOpen(false);
    if (voidCheck) {
      handleVoidChecks();
    } else {
      handleVoidItems();
    }
    dispatch(closeManagerCheck());
  };

    return (
        <Modal
          isOpen={isVoidOpen}
          isModalCenter
          style={popupStyles.modalStyle}
          customClass='h-100 w-100'  customClass2='h-100 w-100'
          noBackground
          loading={props.loading}
          isVoid={true}
        >
          <div className={cn("justify-content-center align-items-center text-center h-100")} style={popupStyles.parentModalStyle}>
          <div className='col-12 fs_18 fw-700 text-center h-20'>Are You Sure?</div>
            <div className="col-12 d-flex p-0 py-1 h-auto text-center align-items-center justify-content-center fs_15">
              <div className="col-9 px-3 fs_15 fw-normal text-center">
                {voidCheck ? props.seat.paidAmount > 0 ?
                  <><text className='fs_15'> {CUSTOM_MESSAGES().CHECK_VOID_ERRER}</text><text> {CUSTOM_MESSAGES().CHECK_VOID} </text></> : CUSTOM_MESSAGES().CHECK_VOID : CUSTOM_MESSAGES().SENT_VOID}
              </div>
              {/* <span className="col-1 fs-22 float-right" role="presentation" onClick={() => { setIsVoidOpen(false); }}>
                <i className="fa fa-times" aria-hidden="true" />
              </span> */}
            </div>
            <div className="col-11 d-flex mt-2 justify-content-center align-items-center align-items-end text-center h-20 position-absolute" style={popupStyles.buttonStyles}>
            <TouchableButton className={cn("col-6 mr-1 btn44 fs_24 fw-600")} style={popupStyles.noButton} type="button" onClick={(e) => { setIsVoidOpen(false); setIsToolsPopUp({ isOpen: false, data: '' }); e.preventDefault(); }}>
                {LABEL().NO}
              </TouchableButton>
            <TouchableButton
              className={cn(
                "col-6 ml-1 btn44 btn-ripple border-0 fs_24 fw-600",
                style.secondary_color
              )}
              type="button"
              onClick={(e) => {e.preventDefault(); handleYesClick()}}
              style={popupStyles.yesButton}
            >
              {LABEL().YES}
            </TouchableButton>
            </div>
          </div>
        </Modal>
    )
}

export default VoidCheckModal;